import { useSyncExternalStore } from 'react'

/** Tailwind's `lg` breakpoint: from here up the app has a sidebar and two panes. */
export const DESKTOP_QUERY = '(min-width: 1024px)'

/** Whether a CSS media query currently matches, updated as it changes. */
export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (onChange) => {
      const list = window.matchMedia(query)
      list.addEventListener('change', onChange)
      return () => list.removeEventListener('change', onChange)
    },
    () => window.matchMedia(query).matches,
    () => false,
  )
}
